/**
 * Staff payroll / leave / holiday permission keys (must match Fakhri-api PERMISSIONS).
 * Used for module access, menu gating, and dashboard cards.
 *
 * Compensation (salary history, payslips, payroll amounts) is gated by payrollPeriods.*
 * — never by employees.view alone.
 */
export const STAFF_SETTINGS_VIEW = "staffSettings.view";
export const STAFF_SETTINGS_EDIT = "staffSettings.edit";

export const OFFICE_HOLIDAYS_VIEW = "officeHolidays.view";
export const OFFICE_HOLIDAYS_CREATE = "officeHolidays.create";
export const OFFICE_HOLIDAYS_EDIT = "officeHolidays.edit";
export const OFFICE_HOLIDAYS_DELETE = "officeHolidays.delete";

export const PAYROLL_PERIODS_VIEW = "payrollPeriods.view";
export const PAYROLL_PERIODS_CREATE = "payrollPeriods.create";
export const PAYROLL_PERIODS_EDIT = "payrollPeriods.edit";
export const PAYROLL_PERIODS_DELETE = "payrollPeriods.delete";
export const PAYROLL_PERIODS_PAY = "payrollPeriods.pay";
export const PAYROLL_PERIODS_REVERSE_PAYOUT = "payrollPeriods.reversePayout";

/** Any of these grants entry to the Staff module (in addition to roster / portal). */
export const STAFF_MODULE_PAYROLL_VIEW_PERMISSIONS = [
  STAFF_SETTINGS_VIEW,
  OFFICE_HOLIDAYS_VIEW,
  PAYROLL_PERIODS_VIEW,
] as const;

/** Permissions that may create/update salary history rows (matches API). */
export const EMPLOYEE_SALARY_HISTORY_WRITE_PERMISSIONS = [
  PAYROLL_PERIODS_EDIT,
  PAYROLL_PERIODS_CREATE,
] as const;

export function canViewEmployeeFinancials(hasPermissionFn: (name: string) => boolean): boolean {
  return hasPermissionFn(PAYROLL_PERIODS_VIEW);
}

export function canWriteEmployeeSalaryHistory(hasPermissionFn: (name: string) => boolean): boolean {
  return EMPLOYEE_SALARY_HISTORY_WRITE_PERMISSIONS.some((p) => hasPermissionFn(p));
}
